import React from "react";


const Welcome = (props) => {
    const { data } = props
    return (
    <h2 style={{color:'#00a359'}}>Bienvenue {data} </h2>
    )
  }
  export default Welcome;